import { render, staticRenderFns } from "./InfoView.vue?vue&type=template&id=b5ec47ae&"
import script from "./InfoView.vue?vue&type=script&lang=js&"
export * from "./InfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5ec47ae')) {
      api.createRecord('b5ec47ae', component.options)
    } else {
      api.reload('b5ec47ae', component.options)
    }
    module.hot.accept("./InfoView.vue?vue&type=template&id=b5ec47ae&", function () {
      api.rerender('b5ec47ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/common/InfoView.vue"
export default component.exports